module.exports = __webpack_public_path__ + "img/ic_12_equipment.2b560f54.svg";